<div class="overdiv">
    <h3>{{dataJson['Ueberschrift']}} <span>{{dataJson['UeberschriftStyle']}}</span></h3>
    <div *ngFor="let item of text; let i = index" style="padding-top: 25px; padding-bottom: 25px;">
        <div class="imageDiv" [ngStyle]="{'flex-direction': i % 2 === 0 ? 'row' : 'row-reverse'}">
            <div style="width: 100%; display: flex; flex-direction: column; align-items: center;">
              <div data-aos="fade-up" style="width: 100%; display: flex; align-items: center; flex-direction: column; max-width: 340px;">
                <img class="fade show" [src]="'./assets/img/people/' + item.image_path + '.webp'" alt="">
                <div class="nameBox"><span>{{ item.name }}</span></div>
              </div>
            </div>
          
            <div class="text" style="font-weight: 200; width: 100%;">
              <h3 style="text-align: left;">{{ item.header }}</h3>
              <ng-container *ngFor="let training of trainings; let tIdx = index">
                <div *ngIf="item.id == training['mitarbeiter_id']">
                  <span [innerHTML]="training['training']"></span> <br>
                </div>
              </ng-container>
        </div>
    </div>
</div>
<div class="wrap-div">
    <div data-aos="fade-up" *ngFor="let image of showTeamSec; let i = index" class="imageDiv" style="flex-direction: column; max-width: 339px;">
        <img [src]="'./assets/img/people/' + image.image_path + '.webp'" alt="">
        <div class="nameBox" style="margin: 0; margin-top: -10px;"><span class="nameSpan">{{image.name}}</span></div>
    </div>
</div>
<div style="width: 100%; display: flex; justify-content: center; align-items: center; margin-top: 20px;">
    <div class="welcomeText">
        <h3 style="width: 100%;">{{dataJson["MitarbeiterSuchenUeberschrift"]}} <b><span>{{dataJson["MitarbeiterSuchenUeberschriftStyle"]}}</span></b></h3>
        <div class="imageDiv">
            
            <div class="text" style="font-weight: 200; text-align: center;" >
                <span>{{dataJson["Block1Text1"]}}</span>
                <br>
                <span>{{dataJson["Block2Text1"]}} <a aria-label="E-Mail-Adresse" style="color: rgb(50, 100, 50);" href="mailto:{{dataJson['block2Link']}}">{{dataJson["block2Link"]}}</a> {{dataJson["Block2Text3"]}}</span>
                <br>
                <span>{{dataJson["Block3Text1"]}}</span>
                <br>
            </div>
        </div>
        
        <div class="TeamButton" style="padding-top: 50px;">
            <a aria-label="Kontakt-Seite" routerLink="/kontakt">{{dataJson["Button"]}}</a>
        </div>
        
      </div>
</div>
